import { Link } from "@tanstack/react-router";
import { ArrowRight, Clock, LifeBuoy, Search } from "lucide-react";
import type { LucideIcon } from "lucide-react";

import { m } from "@/paraglide/messages.js";

type Lead = { id: string; icon: LucideIcon; title: () => string; body: () => string; link?: { to: string; hash?: string; label: () => string } };

/**
 * Beside the form: the quicker answers first (the help centre, a coach's own page), then when a
 * person will write back. Someone looking for their coach lands here often; this page is for the
 * people who run the app, so it says so before they write.
 */
const LEADS: Lead[] = [
  {
    id: "help",
    icon: LifeBuoy,
    title: () => m.contact_aside_help_title(),
    body: () => m.contact_aside_help_body(),
    link: { to: "/help", label: () => m.contact_aside_help_cta() },
  },
  {
    id: "coach",
    icon: Search,
    title: () => m.contact_aside_coach_title(),
    body: () => m.contact_aside_coach_body(),
    link: { to: "/coaches", label: () => m.contact_aside_coach_cta() },
  },
  {
    id: "reply",
    icon: Clock,
    title: () => m.contact_aside_reply_title(),
    body: () => m.contact_aside_reply_body(),
  },
];

export const ContactAside = () => (
  <div className="grid content-start gap-3">
    {LEADS.map((lead) => {
      const Icon = lead.icon;
      return (
        <div key={lead.id} className="flex gap-4 rounded-[28px] border border-border bg-background p-6">
          <span className="grid size-11 shrink-0 place-items-center rounded-2xl bg-[var(--site-wash)] text-[var(--site-ink)]">
            <Icon aria-hidden className="size-5" />
          </span>
          <div className="min-w-0">
            <h2 className="text-lg font-medium tracking-[-0.02em]">{lead.title()}</h2>
            <p className="mt-1 text-[15px] leading-normal text-muted-foreground">{lead.body()}</p>
            {lead.link ? (
              <Link
                to={lead.link.to}
                hash={lead.link.hash}
                className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium transition-colors hover:text-[var(--site-ink)]"
              >
                {lead.link.label()}
                <ArrowRight aria-hidden className="size-4" />
              </Link>
            ) : null}
          </div>
        </div>
      );
    })}
  </div>
);
